import { createReducer, createActions } from 'reduxsauce';
import { JWT_TOKEN } from 'src/utils/constants.json';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

const INIT_STATE = {
    //TODO: verificar depois de new auth
    isLogged: !!cookies.get(JWT_TOKEN),
    sessionUser: {},
};

export const { Types, Creators } = createActions(
    {
        setLogin: ['isLogged'],
        setSessionUser: ['sessionUser'],
        logout: [],
    },
    {
        prefix: 'LOGIN_',
    }
);

const setLogin = (state = INIT_STATE, { isLogged }) => ({
    ...state,
    isLogged,
});

const setSessionUser = (state = INIT_STATE, { sessionUser }) => ({
    ...state,
    sessionUser,
});

const logout = (state = INIT_STATE) => ({
    ...state,
    isLogged: false,
    sessionUser: undefined
});

const handlers = {
    [Types.SET_LOGIN]: setLogin,
    [Types.SET_SESSION_USER]: setSessionUser,
    [Types.LOGOUT]: logout,
};
export default createReducer(INIT_STATE, handlers);
